import { PaymentAccount } from '@uzurv/rideWss/clara';
import { isNullOrUndefined } from './is-null-or-defined';
import moment from 'moment-timezone';

export class PaymentAccountUtil {
  static isPaymentAccountExpired(paymentAccount: PaymentAccount): boolean {
    if (isNullOrUndefined(paymentAccount)) {
      return false;
    }

    return moment(paymentAccount.cardExpiration).isBefore(moment());
  }
}
